<template>
  <div class="contact margin-between-section">
    <div class="row not-margin">
      <div class="col-md-12 container-info">
        <div class="row info margin-zero">
          <div class="col-lg-2 padding-zero">
            <h1>
              <img src="../assets/images/user.png" /> Admin
            </h1>
          </div>
        </div>
      </div>
    </div>

    <div class="not-margin">
      <Users />
    </div>
  </div>
</template>

<script>

import Users from '@/components/Users';

export default {
  name: "contact",
    components: {
      Users
  },
  data() {
    return {
    }
  },
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  text-decoration: none;
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li {
  display: inline;
}

.btn-position {
  font-size: 10px;
  border-bottom: 1px solid #000;
  width: 25px;
  padding: 0;
  margin-right: 5px;
  text-transform: uppercase;
  font-family: "plain medium", arial;
}

.margin-zero {
  margin: 0;
}
.padding-zero {
  padding: 0;
}

.c-header {
  width: 100%;
}

.info {
  text-align: left;
  width: 100%;
}

.info h1 {
  font-size: 20px;
  font-family: "plain regular", arial;
  display: inline-block;
  float: left;
  font-weight: 600;
  
}

.container-age {
  display: inline-block;
}

.info h1 img {
  width: 20px;
  margin-right: 10px;
  margin-top: -8px;
}

.info p {
  font-size: 18px;
}

.container-info {
  display: flex;
}

.not-margin {
  margin: 0;
}
.not-padding {
  padding: 0;
}

.info-form-contact {
  text-align: left;
}

.info-form-contact h1 {
  font-size: 16px;
  font-family: "plain regular", arial;
}

.info-form-contact p {
  font-size: 8px;
  margin-top: 15px;
  color: rgb(151, 151, 151);
}

.info-form-contact a {
  font-size: 8px;
  margin-top: 15px;
  color: rgb(116, 116, 116);
  text-decoration: underline;
}

.con-i input {
  border: 0;
  border-bottom: 1px solid #000;
  width: 120px;
  font-size: 12px;
  margin-left: 5%;
}

.send-b {
  border: 1px solid #000;
  border-radius: 0;
  margin-left: 0px;
  font-size: 12px;
  padding: 5px 30px;
  margin-bottom: 9px;
}

.container-drop {
  float: right;
}

.dropdown {
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  margin-left: 15px;
  margin-right: 5px;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
}

.dropdown-btn {
  font-size: 13px;
}

.dropdown-item {
  font-size: 13px;
}

.instruction {
  color: #000;
  font-size: 11px !important;
  font-family: "plain regular", arial;
}

.instruction-position {
  color: rgb(138, 138, 138);
  font-size: 9px !important;
}

.camp-position {
  position: relative;
  display: inline-block;
}

.container-footer-drop {
  position: relative;
  display: inline-block;
  float: right;
}

.container-footer-drop img {
  display: inline-block;
}

.container-footer-drop p {
  display: inline-block;
  float: right;
}

.instruction-mapa {
  color: #000;
  font-size: 9px !important;
  width: 180px;
  margin-left: 10px;
}

  .btn-d {
    padding: 0.375rem 2.75rem;
  }
</style>
